import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import './Breadcrumbs.css';

interface BreadcrumbItem {
  label: string;
  path: string;
}

const Breadcrumbs: React.FC = () => {
  const location = useLocation();
  
  const getBreadcrumbs = (): BreadcrumbItem[] => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const breadcrumbs: BreadcrumbItem[] = [];
    
    let currentPath = '';
    
    pathSegments.forEach((segment, index) => {
      currentPath += `/${segment}`;
      
      const label = getBreadcrumbLabel(segment);
      breadcrumbs.push({
        label,
        path: currentPath
      });
    });
    
    return breadcrumbs;
  };
  
	  const getBreadcrumbLabel = (segment: string): string => {
	    const labels: { [key: string]: string } = {
	      'o-nas': 'O nas',
	      'oferta': 'Oferta',
	      'certyfikaty': 'Certyfikaty',
	      'cennik': 'Cennik',
	      'kontakt': 'Kontakt',
	      'informacje-dla-pacjenta': 'Dla pacjenta',
	      'polityka-cookies': 'Polityka cookies',
	      'informacje-rodo': 'Informacje RODO',
	      'prawa-pacjenta': 'Prawa pacjenta',
	      'strona-pokazowa': 'Strona pokazowa'
	    };
    
    return labels[segment] || segment;
  };
  
  const breadcrumbs = getBreadcrumbs();
  
  if (breadcrumbs.length === 0) {
    return null;
  }
  
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Strona główna",
        "item": "https://www.fizjoterapia-pabich.pl/"
      },
      ...breadcrumbs.map((item, index) => ({
        "@type": "ListItem",
        "position": index + 2,
        "name": item.label,
        "item": `https://www.fizjoterapia-pabich.pl${item.path}`
      }))
    ]
  };
  
  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
      <nav className="breadcrumbs" aria-label="Breadcrumb">
        <ol className="breadcrumb-list">
          <li className="breadcrumb-item">
            <Link to="/" className="breadcrumb-link">
              <Home size={16} />
              <span>Strona główna</span>
            </Link>
          </li>
          {breadcrumbs.map((item, index) => (
            <li key={index} className="breadcrumb-item">
              <ChevronRight size={16} className="breadcrumb-separator" />
              {index === breadcrumbs.length - 1 ? (
                <span className="breadcrumb-current">{item.label}</span>
              ) : (
                <Link to={item.path} className="breadcrumb-link">
                  {item.label}
                </Link>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
};

export default Breadcrumbs;
